
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/crypto-project-of-the-year/2024",
      function () {
        return require("private-next-pages/crypto-project-of-the-year/2024.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/crypto-project-of-the-year/2024"])
      });
    }
  